import instObj from '@/backend/axios-instances'

const resource = "/supplier"
const instance = instObj.baseInstance

export default {
  get(supplierId, parameters) {
    return instance.get(`${resource}/${supplierId}`, { params: parameters });
  },
  put(supplierId, data, parameters) {
    return instance.put(`${resource}/${supplierId}`, data, { params: parameters });
  },
  delete(supplierId) {
    return instance.delete(`${resource}/${supplierId}`);
  }
}
